import Swiper from 'swiper/bundle';

export function initSwiperExample(block) {
	const swiperElement = block.querySelector('.swiper');
	if (!swiperElement) return null;

	return new Swiper(swiperElement, {
		loop: false,
		slidesPerView: 1,
		spaceBetween: 24,
		autoHeight: true,
		navigation: {
			nextEl: block.querySelector('.swiper-button-next'),
			prevEl: block.querySelector('.swiper-button-prev')
		},
		pagination: {
			el: block.querySelector('.swiper-pagination'),
			clickable: true
		}
	});
}

export default function swiperExampleBlock(options = {}) {
	try {
		const {block} = options;

		if (!block || block.dataset.swiperExampleReady === 'true') return;

		const swiper = initSwiperExample(block);
		if (!swiper) return;

		block.dataset.swiperExampleReady = 'true';
	} catch (error) {
		console.error(error);
	}
}
